module.exports = __webpack_public_path__ + "img/data-source.30f07172.svg";